import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "web",
  "use": "web-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"web\"><path d=\"M2 14h36M14 38V14M6 2h28a4 4 0 014 4v28a4 4 0 01-4 4H6a4 4 0 01-4-4V6a4 4 0 014-4z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/web.svg
// module id = xTXA
// module chunks = 39 44